<template>
  <div class="g-footer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'GFooter'
}
</script>

<style scoped>
.g-footer {}
</style>
